import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { Button } from "@whoosh/design-system/src/components/controls";
import { Box } from "@whoosh/design-system/src/components/primitive";

import { BookingCard } from "../../../../../../../features/BookingCard";
import { EmptyBookingList } from "./EmptyBookingList";
import { BookingList_Client$key } from "./__generated__/BookingList_Client.graphql";

type BookingListProps = {
  fragmentRef: BookingList_Client$key;
  setPageCursor: (cursor: string | null) => void;
};

export const BookingList = ({
  fragmentRef,
  setPageCursor,
}: BookingListProps) => {
  const data = useFragment(BookingListClientFragmentString, fragmentRef);
  if (data.bookings?.edges?.length === 0) {
    return <EmptyBookingList />;
  }

  return (
    <Box py={4} justifyContent="center" alignItems="center" px={6}>
      {data?.bookings?.edges?.map((booking) => {
        return booking?.node ? (
          <Box key={booking.node.id} mb={4} width="100%">
            <BookingCard width="100%" BookingCardRef={booking.node} />
          </Box>
        ) : null;
      })}
      {data.bookings?.pageInfo.hasNextPage ? (
        <Button
          width="100%"
          variant="secondary"
          onPress={() =>
            setPageCursor(data?.bookings?.pageInfo.endCursor ?? "")
          }
          accessibilityLabel={t`Load More button`}
        >
          {t`Load More`}
        </Button>
      ) : null}
    </Box>
  );
};

export const BookingListClientFragmentString = graphql`
  fragment BookingList_Client on Client {
    ... on Member {
      bookings(
        dateLte: $dateGTE
        orderBy: { field: DATE_TIME, direction: DESC }
        first: $first
        after: $after
      ) @connection(key: "BookingList_bookings") {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        count
        edges {
          node {
            id
            ...BookingCard_Booking
          }
        }
      }
    }
    ... on Customer {
      bookings(
        dateLte: $dateGTE
        orderBy: { field: DATE_TIME, direction: DESC }
        first: $first
        after: $after
      ) @connection(key: "BookingList_bookings") {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        count
        edges {
          node {
            id
            ...BookingCard_Booking
          }
        }
      }
    }
  }
`;
